import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreakPointService {

  sidenavExpanded: boolean = true;
  isHandset: boolean = false;
  isTablet: boolean = false;
  isWeb: boolean = false;

  isHandset$: Observable<boolean>;
  isTablet$: Observable<boolean>;
  isWeb$: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.isHandset$ = this.breakpointObserver.observe([Breakpoints.Handset])
      .pipe(
        map(result => result.matches),
        shareReplay()
      );

    this.isTablet$ = this.breakpointObserver.observe([Breakpoints.Tablet])
      .pipe(
        map(result => result.matches),
        shareReplay()
      );

    this.isWeb$ = this.breakpointObserver.observe([Breakpoints.Web])
      .pipe(
        map(result => result.matches),
        shareReplay()
      );

    this.initializeObservables();
  }

  private initializeObservables(): void {
    this.isHandset$.subscribe(isHandset => {
      if (isHandset) {
        this.isHandset = true;
        this.isTablet = false;
        this.isWeb = false;
        this.sidenavExpanded = true;
      }
    });

    this.isTablet$.subscribe(isTablet => {
      if (isTablet) {
        this.isHandset = false;
        this.isTablet = true;
        this.isWeb = false;
        this.sidenavExpanded = false;
      }
    });

    this.isWeb$.subscribe(isWeb => {
      if (isWeb) {
        this.isHandset = false;
        this.isTablet = false;
        this.isWeb = true;
        this.sidenavExpanded = true;
      }
    });
  }
}
